import NotesManagement from "../../components/notes/notes";


export default function () {
  return (
      <NotesManagement />
  );
}
